
/*
    Since we have to use a location dropdown selection so often,
    I just made a control that handles the data loading and interaction
*/

import React, { createRef } from "react";

import MainContext from "../MainContext";

import { getLocations } from "../Requests/UtilityRequests";

/*
PROPS:

setFocus - boolean, whether we set focus on element after load
selected - the location value that's selected
updateValue - function to call when user changes the selection
hasAllOption - T/F for whether to add an "ALL" option to the list

*/

export default class LocationDropDown extends React.Component {

    static contextType = MainContext;

    constructor(){
        super();
        this.state = {
            locations: []
        };

        this.LocationRef = createRef();
    }

    componentDidMount(){
        // get the locations
        const request = () => getLocations();
        const then = ({data}) => {
            this.setState({locations: data}, () => {
                if(this.props.setFocus){
                    this.LocationRef.current.focus();
                }
            });
        };
        this.context.runProcessing(request, then, "getLocations");
    }

    render() {
        return (
            <select
                ref={this.LocationRef}
                name="location"
                value={this.props.selected}
                onChange={this.props.updateValue}
                style={{
                    width: "200px"
                }}
            >
                <option key={-1} value="">None</option>
                {
                    this.props.hasAllOption
                    ? <option key={-2} value="ALL">ALL</option>
                    : null
                }
                {
                    this.state.locations.map((location, index) => {
                        return (
                            <option key={index} value={location.bus_terminal_code}>
                                {location.bus_terminal_name}
                            </option>
                        ) 
                    })
                }
            </select>
        );
    }
}